var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner" },
    [
      !_vm.dialogDistroy
        ? _c(
            "el-dialog",
            {
              staticClass: "realSendReceiveDialog",
              attrs: {
                visible: _vm.innerVisible,
                "close-on-click-modal": false,
                "close-on-press-escape": false,
                title: _vm.title,
                width: _vm.$selectByLang("360px", "400px"),
                top: "5vh"
              },
              on: {
                "update:visible": function($event) {
                  _vm.innerVisible = $event
                }
              }
            },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    "label-width": _vm.$selectByLang("85px", "125px"),
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": _vm.$selectByLang("85px", "125px"),
                        "label-position": "left"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("WriteOff.paymentMethod") } },
                        [
                          _c("cargo-advance-select", {
                            style: _vm.formItemWidth,
                            attrs: {
                              clearable: false,
                              "select-type":
                                _vm.selectTypeNames
                                  .local_cache_ClearingConstants$AMOUNT_RECEIVE_TYPES,
                              cache: false,
                              "default-value": _vm.receiveType,
                              "static-options": _vm.receiveTypeArray,
                              "tag-name": _vm.tagName
                            },
                            on: { parentCallBack: _vm.receiveTypeChangeHandler }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("WriteOff.bankReceiptStatus") }
                        },
                        [
                          _c("cargo-advance-select", {
                            style: _vm.formItemWidth,
                            attrs: {
                              "select-type":
                                _vm.selectTypeNames
                                  .local_cache_ClearingConstants$CASH_TRANSFER_STATES,
                              "callback-method-type": "value",
                              "default-value": _vm.cashTransferState,
                              "callback-params": { key: "cashTransferState" },
                              clearable: false,
                              "tag-name": _vm.tagName
                            },
                            on: {
                              parentCallBack: _vm.cashTransferStateChangeHandler
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("WriteOff.ourSideBank") } },
                        [
                          _c("cargo-advance-select", {
                            style: _vm.formItemWidth,
                            attrs: {
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.static_data_BankAccount,
                              cache: false,
                              "method-params": {
                                officeUuid: _vm.currentOfficeUuid
                              },
                              "default-value": _vm.ourBankAccountId,
                              "static-options": _vm.ourBankAccountArray,
                              "custom-label": _vm.ourBankAccountLabel,
                              "options-width": "450px"
                            },
                            on: { parentCallBack: _vm.ourBankChangeHandler }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("WriteOff.ourSideAccount") } },
                        [
                          _c("el-input", {
                            style: _vm.formItemWidth,
                            model: {
                              value: _vm.ourBankAccountNo,
                              callback: function($$v) {
                                _vm.ourBankAccountNo = $$v
                              },
                              expression: "ourBankAccountNo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("WriteOff.proofNo") } },
                        [
                          _c("el-input", {
                            style: _vm.formItemWidth,
                            model: {
                              value: _vm.actualAmount.voucherNo,
                              callback: function($$v) {
                                _vm.$set(_vm.actualAmount, "voucherNo", $$v)
                              },
                              expression: "actualAmount.voucherNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": _vm.$selectByLang("85px", "125px"),
                        "label-position": "left"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("WriteOff.currency") } },
                        [
                          _c("cargo-advance-select", {
                            style: _vm.formItemWidth,
                            attrs: {
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Currency,
                              "default-value": _vm.currency,
                              clearable: false
                            },
                            on: { parentCallBack: _vm.currencyChangeHandler }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "redLabel",
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_ReceiptAmount")
                          }
                        },
                        [
                          _c("el-input-number", {
                            style: _vm.formItemWidth,
                            attrs: {
                              disabled: _vm.isPrePayment,
                              min: 0,
                              max: 99999999,
                              precision: 2,
                              "controls-position": "right"
                            },
                            model: {
                              value: _vm.actualAmount.amount,
                              callback: function($$v) {
                                _vm.$set(_vm.actualAmount, "amount", $$v)
                              },
                              expression: "actualAmount.amount"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_PaymentCompany")
                          }
                        },
                        [
                          _c("el-input", {
                            style: _vm.formItemWidth,
                            model: {
                              value: _vm.actualAmount.paymentCompany,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.actualAmount,
                                  "paymentCompany",
                                  $$v
                                )
                              },
                              expression: "actualAmount.paymentCompany"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isPrePayment,
                              expression: "isPrePayment"
                            }
                          ],
                          attrs: { label: _vm.$t("WriteOff.settleAccountsTo") }
                        },
                        [
                          _c("cargo-company-select", {
                            attrs: {
                              "method-params": {},
                              "default-value":
                                Number(_vm.settlementCompanyId) || "",
                              "tag-name": _vm.tagName,
                              "custom-style": _vm.formItemWidth
                            },
                            on: { change: _vm.companyIdChangeHandler }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("WriteOff.theOppositeSideBank")
                          }
                        },
                        [
                          _c("el-input", {
                            style: _vm.formItemWidth,
                            model: {
                              value: _vm.actualAmount.companyBank,
                              callback: function($$v) {
                                _vm.$set(_vm.actualAmount, "companyBank", $$v)
                              },
                              expression: "actualAmount.companyBank"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("WriteOff.theOppositeSideAccount")
                          }
                        },
                        [
                          _c("el-input", {
                            style: _vm.formItemWidth,
                            model: {
                              value: _vm.actualAmount.companyBankAccount,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.actualAmount,
                                  "companyBankAccount",
                                  $$v
                                )
                              },
                              expression: "actualAmount.companyBankAccount"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.lbPayDate } },
                    [
                      _c("el-date-picker", {
                        style: { width: "150px", paddingRight: "10px" },
                        attrs: {
                          "value-format": "yyyy-MM-dd",
                          type: "date",
                          clearable: false,
                          "default-value": new Date()
                        },
                        model: {
                          value: _vm.payReceiveDate,
                          callback: function($$v) {
                            _vm.payReceiveDate = $$v
                          },
                          expression: "payReceiveDate"
                        }
                      }),
                      _c(
                        "el-checkbox",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showPublish,
                              expression: "showPublish"
                            }
                          ],
                          style: { width: "50px" },
                          model: {
                            value: _vm.isPublish,
                            callback: function($$v) {
                              _vm.isPublish = $$v
                            },
                            expression: "isPublish"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Publish")))]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Payment.purpose") } },
                    [
                      _c("el-input", {
                        style: _vm.formItemWidth,
                        attrs: { type: "textarea", rows: 3 },
                        model: {
                          value: _vm.actualAmount.purpose,
                          callback: function($$v) {
                            _vm.$set(_vm.actualAmount, "purpose", $$v)
                          },
                          expression: "actualAmount.purpose"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Payment.postscript") } },
                    [
                      _c("el-input", {
                        style: _vm.formItemWidth,
                        attrs: { type: "textarea", rows: 3 },
                        model: {
                          value: _vm.actualAmount.postscript,
                          callback: function($$v) {
                            _vm.$set(_vm.actualAmount, "postscript", $$v)
                          },
                          expression: "actualAmount.postscript"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Payment.remarks") } },
                    [
                      _c("el-input", {
                        style: _vm.formItemWidth,
                        attrs: { type: "textarea", rows: 3 },
                        model: {
                          value: _vm.actualAmount.remark,
                          callback: function($$v) {
                            _vm.$set(_vm.actualAmount, "remark", $$v)
                          },
                          expression: "actualAmount.remark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isPrePayment,
                          expression: "!isPrePayment"
                        }
                      ],
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.saveOrSaveAndAddHandler(false)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Payment.saveAndAdd")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.saveOrSaveAndAddHandler(true)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.innerVisible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }